<template>
  <div :class="['input-wrapper', { 'input_error': error }, { 'input_disabled': disabled }]">
    <label
      v-if="label"
      :for="id"
      class="input__label"
    >
      {{ label }}
      <span v-if="required" class="input__label-required">*</span>
    </label>
    <div class="input__field-container">
      <component
        :is="isTextarea ? 'textarea' : 'input'"
        :id="id"
        ref="input"
        v-mask="inputMask"
        v-bind="$attrs"
        :value="value"
        :class="['input__field input__field_phone', textFieldClasses]"
        @input="onInput"
        @change="onChange"
        @focus="onFocus"
        @blur="onBlur"
      />
    </div>
    <transition name="slide-from-top">
      <span
        v-if="error && errorMsg"
        class="input__error-msg"
      >
        {{ errorMsg }}
      </span>
    </transition>
  </div>
</template>

<script>
  import { VueMaskDirective } from 'v-mask'
  export default {
    name: 'BasePhone',
    directives: { mask: VueMaskDirective },
    inheritAttrs: false,
    props: {
      value: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      errorMsg: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        error: null,
        isOnFocus: false,
        valueLength: 0
      }
    },
    computed: {
      id () {
        return `input-${this._uid}`
      },
      required () {
        return 'required' in this.$attrs && this.$attrs.required
      },
      isTextarea () {
        return this.$attrs.type === 'textarea'
      },
      inputMask () {
        return this.$attrs.type === 'tel' ? '+380-##-###-##-##' : ''
      },
      textFieldClasses () {
        return [
          { 'input__field_focus': this.isOnFocus },
          { 'input__field_has-content': this.value }
        ]
      },
      getValueLength () {
        return this.isTextarea ? this.$refs.input.value.length : ''
      }
    },
    watch: {
      errorMsg: {
        handler (msg) {
          this.error = !!msg
        }
      }
    },
    methods: {
      onInput (e) {
        this.error = false
        this.$emit('input', e.target.value)
        if (this.isTextarea) {
          this.valueLength = e.target.value.length
        }
      },
      onChange (e) {
        this.$emit('change', e.target.value)
      },
      onFocus () {
        this.isOnFocus = true

        this.$emit('focus')
      },

      onBlur () {
        this.isOnFocus = false


        if (this.$refs.input.hasAttribute('minlength') && this.$refs.input.value.length < parseInt(this.$refs.input.getAttribute('minlength'))) {
          this.error = true
        } else {
          this.error = false
        }

        this.$emit('blur')
      }
    }
  }
</script>

<style lang="scss">
</style>
